<template>
  <section
    class="section section-primary is-medium animated preFadeInUp fadeInUp"
    style="height: 100vh"
  >
    <div class="container">
      <div
        class="flex-card simple-shadow"
        style="max-width: 650px; margin: 0 auto"
      >
        <header class="modal-card-head">
          <p class="modal-card-title p-20"><b> الشروط و الاحكام </b></p>
        </header>
        <div class="card-body" style="padding-top: 0px">
          <div class="content">
            <section
              class="modal-card-body"
              style="
                padding: 20px;
                max-height: 60vh;
                overflow-y: auto;
                text-align: right;
              "
            >
              <div class="mt-5 mb-10">
                <div
                  v-if="terms"
                  class="has-text-right is-black is-size-6 has-text-justified"
                  v-html="terms"
                ></div>
                <loading
                  v-else
                  line-fg-color="#2d3f51"
                  size="large"
                  class="margin-100"
                  spacing="2"
                  text-fg-color="#fff"
                  message="الرجاء الإنتظار"
                />
              </div>
            </section>
          </div>
          <div class="mt-20" v-if="terms">
            <a
              class="button secondary-btn btn-align is-bold is-medium"
              @click="agreeonterms"
            >
              <b>أوافق علي الشروط و الاحكام </b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Terms",
  data() {
    return {
      user: null,
      terms: null,
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    getKycTerms() {
      axios
        .get("/kyc/terms")
        .then((response) => {
          if (response.data.status === "success") {
            this.terms = response.data.data;
          }
        })
        .catch((error) => {});
    },
    agreeonterms() {
      axios
        .post("/admin/kyc/update/isAgreeOnTerms", {
          id: this.user[1],
          agreedOnService: "KYC",
        })
        .then((response) => {
          this.$root.kick(response.data.message);
          localStorage.setItem("isAgreeOnTerms", "true");
          this.$router.push("/portal");
        })
        .catch((error) => {});
    },
  },
  mounted() {
    this.getKycTerms();
  },
};
</script>
